<template>
  <div class="pc-viewer">
    <AppMapPointPanelHeader :header="header" @close="$emit('close')" />
    <div class="pc-viewer__content">
      <AppMapPointPanelFirstRow @edit="edit" :title="pc.name" :id="pc.id" :img="iconSrc" :has-edit="can(PN.PC_UPDATE)" :has-preview="false" />
      <table class="table user-view-table m-0">
        <tbody>
          <tr>
            <th>Model:</th>
            <td>{{ pc.model }}</td>
          </tr>
          <tr>
            <th>Asset number:</th>
            <td>{{ pc.asset_num }}</td>
          </tr>
          <tr>
            <th>Note:</th>
            <td class="multiline">{{ pc.description }}</td>
          </tr>
          <tr>
            <th>Department:</th>
            <td>{{ department.name }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import * as PN from '@/utils/PermissionNames'
import AppMapPointPanelHeader from '@/components/shared/AppMapPointPanelHeader.vue'
import { getItemHeader } from '@/components/shared/helpers'
import AppMapPointPanelFirstRow from '@/components/shared/AppMapPointPanelFirstRow.vue'
import { getIconUrl } from '@/components/leaflet/Icon'

export default {
  name: 'PcViewer',
  components: { AppMapPointPanelFirstRow, AppMapPointPanelHeader },
  data: () => ({
    PN,
    pcTemp: {}
  }),
  props: {
    id: {
      type: [String, Number],
      required: true
    },
    point: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapGetters('pc', ['getPc']),
    ...mapGetters('department', ['getDepartment']),
    ...mapGetters('rbac', ['can']),
    iconSrc() {
      return getIconUrl(this.point.icon_id, this.point.file_updated_at)
    },
    header() {
      return getItemHeader(this.point, 'PC')
    },
    pc() {
      return this.getPc(this.id) || {}
    },
    department() {
      return this.getDepartment(this.pc.department_id) || {}
    }
  },
  methods: {
    edit() {
      this.$emit('edit')
    }
  }
}
</script>

<style>
.pc-viewer__content {
  padding: 24px;
}
</style>
